import { PAYMENT_METHOD } from '../../payment/constants';
import type { CartPaymentOption, CreditCardType, PaymentType } from '../../payment/types';

/** The chosen card type for the credit card, else the option's preselected type; '' without a selection. */
export function readSubmittedPaymentType(
  selectedOption: CartPaymentOption | undefined,
  selectedCreditCardType: CreditCardType | null
): PaymentType | '' {
  if (!selectedOption) {
    return '';
  }

  if (selectedOption.method === PAYMENT_METHOD.CREDIT_CARD && selectedCreditCardType) {
    return selectedCreditCardType;
  }

  return selectedOption.selectedType;
}
